"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TrashIcon = function TrashIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    viewBox = _ref.viewBox;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter0_ddd)"
  }, /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "22",
    cy: "22.0001",
    rx: "12",
    ry: "12.4434",
    fill: "#78023E"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 17.8524L26 16.8154L22 20.9632L18 16.8154L17 17.8524L21 22.0002L17 26.148L18 27.1849L22 23.0371L26 27.1849L27 26.148L23 22.0002L27 17.8524Z",
    fill: "#FFFDFB"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "filter0_ddd",
    x: "0",
    y: "0.556641",
    width: "44",
    height: "44.8868",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: "5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.00784314 0 0 0 0 0.243137 0 0 0 0.14 0"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dy: "4"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.00784314 0 0 0 0 0.243137 0 0 0 0.1 0"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.00784314 0 0 0 0 0.243137 0 0 0 0.12 0"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  }))));
};
TrashIcon.defaultProps = {
  width: '44',
  height: '46',
  viewBox: '0 0 44 46'
};
TrashIcon.propTypes = {
  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,
  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,
  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string
};
var _default = exports["default"] = TrashIcon;